





















import { Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component
export default class VisitCountryMatch extends mixins(PlanLimitsMixin) {
  @Prop() conditions: any;
  
  value: string = 'IS_NOT_MATCHING';
  predicate: string = 'EQUALS';

  @Watch('conditions', {
    immediate: true
  })
  onConditionsChanged(value: any) {
    if(!value.visitCountryMatch) {
      this.$set(this.conditions, 'visitCountryMatch', {
        predicate: 'EQUALS',
        values: 'IS_NOT_MATCHING'
      });
    }
  }

  @Watch('value')
  onValueChanged(value: string) {
    this.$set(this.conditions.visitCountryMatch, 'values', value);
  }

  @Watch('predicate')
  onPredicateChanged(value: string) {
    this.$set(this.conditions.visitCountryMatch, 'predicate', value);
  }

  mounted() {
    this.value = this.conditions.visitCountryMatch.values;
  }

}
